import React, { useEffect, useState } from "react";
import { ReactComponent as EditIcon } from "../../Global Icons/Edit.svg";
import { ReactComponent as DeleteIcon } from "../../Global Icons/Delete.svg";
import { ReactComponent as CloseIcon } from "../../Global Icons/CancelButton.svg";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import { useDispatch, useSelector } from "react-redux";
import {
  addVR,
  removeVr,
  addThreeSixtyPrevVideo
} from "../../Redux/Actions/projectActions";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import AddImage from "../../Global Functions/addImage";
import "./addVr.css";

const AddVr = ({ vrData, onVrRemoved, onClose }) => {
  const [formData, setFormData] = useState({
    configuration: "",
    configuration_id: "",
    iframe_url: "",
    is_user_vr: true,
  });

  const [urlIframe, setUrlIframe] = useState({
    project_id: vrData?.data?._id || "",
    three_sixty: [],
  });

  const [activeTab, setActiveTab] = useState("existing");
  const [previewVideo, setPreviewVideo] = useState("");
  const [previewVideoPreview, setPreviewVideoPreview] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [otherPopup, setOtherPopup] = useState(false);

  const [videoUploading, setVideoUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadedVideoUrl, setUploadedVideoUrl] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { units } = useSelector((state) => state.units || {});

  useEffect(() => {
    if (vrData?.data?._id) {
      setUrlIframe((prevData) => ({
        ...prevData,
        project_id: vrData.data._id,
      }));
    }

    if (vrData?.data?.three_sixty && vrData.data.three_sixty.length > 0) {
      setUrlIframe((prevData) => ({
        ...prevData,
        three_sixty: vrData.data.three_sixty,
      }));
    } else {
      setUrlIframe((prevData) => ({
        ...prevData,
        three_sixty: [],
      }));
    }
  }, [vrData]);

  useEffect(() => {
    const videoUrl = vrData?.data?.three_sixty_prev_video;
    setPreviewVideo(videoUrl || "");
    setPreviewVideoPreview(videoUrl || "");
    setUploadedVideoUrl("");
  }, [vrData]);

  const handlePreviewVideoChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("video/")) {
      return toast.error("Please select a valid video file!");
    }

    setPreviewVideoPreview(URL.createObjectURL(file));
    setPreviewVideo(file.name);
    setUploadedVideoUrl("");

    setVideoUploading(true);
    setUploadProgress(0);

    const progressInterval = setInterval(() => {
      setUploadProgress((prev) => {
        if (prev >= 90) {
          clearInterval(progressInterval);
          return 90;
        }
        return prev + 10;
      });
    }, 300);

    try {
      const responseUrl = await AddImage(file);
      clearInterval(progressInterval);
      setUploadProgress(100);

      if (responseUrl) {
        setUploadedVideoUrl(responseUrl);
        setPreviewVideoPreview(responseUrl);
        setPreviewVideo(responseUrl);
        toast.success("Video uploaded! Click Save to confirm.");
      }
    } catch (error) {
      clearInterval(progressInterval);
      toast.error("Video upload failed!");
      console.error("Upload error:", error);
      setPreviewVideoPreview("");
      setPreviewVideo("");
    } finally {
      setVideoUploading(false);
      setTimeout(() => setUploadProgress(0), 1000);
      e.target.value = "";
    }
  };

  const handleRemoveVideo = () => {
    setUploadedVideoUrl("");
    setPreviewVideo("");
    setPreviewVideoPreview("");
  };

  // CHANGE 2: In handlePreviewVideoSubmit, replace the if/else dispatch block
  const handlePreviewVideoSubmit = async () => {
    const finalUrl = uploadedVideoUrl || vrData?.data?.three_sixty_prev_video;

    if (!finalUrl) {
      return toast.error("Please upload a preview video first!");
    }

    try {
      const payload = new FormData();
      payload.append("project_id", vrData?.data?._id);
      payload.append("three_sixty_prev_video", finalUrl);

      // ✅ Use addThreeSixtyPrevVideo for both add and update
      const response = await dispatch(addThreeSixtyPrevVideo(payload));

      if (response?.statusCode === 200) {
        const savedUrl = response?.data?.three_sixty_prev_video || finalUrl;
        setPreviewVideoPreview(savedUrl);
        setPreviewVideo(savedUrl);
        setUploadedVideoUrl("");

        if (typeof onVrRemoved === "function") {
          onVrRemoved();
        }
      }
    } catch (error) {
      toast.error("Failed to save preview video");
    }
  };
  const handleAddEntry = (event) => {
    event.preventDefault();

    const { configuration, configuration_id, iframe_url, is_user_vr } = formData;

    if (!configuration || !configuration_id || !iframe_url) {
      return toast.error("All fields are required!");
    }

    if (editingIndex !== null) {
      setUrlIframe((prev) => ({
        ...prev,
        three_sixty: prev.three_sixty.map((item, index) =>
          index === editingIndex
            ? { ...item, configuration, configuration_id, iframe_url, is_user_vr }
            : item
        ),
      }));
      toast.success("VR Tour updated successfully!");
      setEditingIndex(null);
    } else {
      setUrlIframe((prev) => ({
        ...prev,
        three_sixty: [
          ...prev.three_sixty,
          { configuration, configuration_id, iframe_url, is_user_vr, key_saved: false },
        ],
      }));
      toast.success("VR Tour added successfully!");
    }

    setFormData({ configuration: "", configuration_id: "", iframe_url: "", is_user_vr: true });
    setOtherPopup(false);
  };

  const handleEdit = (index) => {
    const vrToEdit = urlIframe.three_sixty[index];
    setFormData({
      configuration: vrToEdit.configuration,
      configuration_id: vrToEdit.configuration_id,
      iframe_url: vrToEdit.iframe_url,
      is_user_vr: vrToEdit.is_user_vr,
    });
    setEditingIndex(index);
    setOtherPopup(vrToEdit.configuration_id === "others");
    setTimeout(() => {
      document.querySelector(".vr-form-section")?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, 100);
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setOtherPopup(false);
    setFormData({ configuration: "", configuration_id: "", iframe_url: "", is_user_vr: true });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (urlIframe.three_sixty.length === 0) {
        return toast.error("Please Add the link using ADD Button!!");
      }
      const response = await dispatch(addVR(urlIframe));
      if (response?.statusCode === 200) {
        if (typeof onVrRemoved === "function") onVrRemoved();
        navigate("/manage_projects");
      }
    } catch (error) {
      toast.error("Failed to submit VR Tours");
    }
  };

  const handleRemove = async (indexToRemove) => {
    const vrToRemove = urlIframe.three_sixty[indexToRemove];
    if (!vrToRemove || !vrToRemove._id) {
      setUrlIframe((prevData) => ({
        ...prevData,
        three_sixty: prevData.three_sixty.filter((_, index) => index !== indexToRemove),
      }));
      toast.success("VR Tour removed!");
      return;
    }
    try {
      const removePayload = { project_id: urlIframe.project_id, three_sixty_id: vrToRemove._id };
      const response = await dispatch(removeVr(removePayload));
      if (response?.statusCode === 200) {
        setUrlIframe((prevData) => ({
          ...prevData,
          three_sixty: prevData.three_sixty.filter((_, index) => index !== indexToRemove),
        }));
        toast.success("VR Tour deleted successfully!");
        if (typeof onVrRemoved === "function") onVrRemoved();
      } else {
        toast.error("Failed to remove VR");
      }
    } catch (error) {
      toast.error("Error removing VR");
    }
  };

  const handleClearAll = () => {
    setUrlIframe((prevData) => ({ ...prevData, three_sixty: [] }));
    setEditingIndex(null);
    setOtherPopup(false);
    setFormData({ configuration: "", configuration_id: "", iframe_url: "", is_user_vr: true });
    if (typeof onClose === "function") onClose();
  };

  return (
    <div className="vr-modal-containers">
      <div className="vr-modal-headers">
        <h2 className="vr-modal-title">Add 360° / VR Experience</h2>
        <CloseIcon className="vr-close-icon" onClick={handleClearAll} title="Close" />
      </div>

      <div className="vr-tab-switcher">
        <button
          type="button"
          className={`vr-tab-btn ${activeTab === "existing" ? "active" : ""}`}
          onClick={() => setActiveTab("existing")}
        >
          Add VR
        </button>
        <button
          type="button"
          className={`vr-tab-btn ${activeTab === "preview" ? "active" : ""}`}
          onClick={() => setActiveTab("preview")}
        >
          Upload VR Prev Video
        </button>
      </div>

      <div className="vr-modal-content">
        {activeTab === "existing" ? (
          <>
            {urlIframe.three_sixty && urlIframe.three_sixty.length > 0 && (
              <div className="vr-list-section">
                <h3 className="vr-list-heading">Added VR Tours</h3>
                <div className="vr-list-container">
                  {urlIframe.three_sixty.map((data, index) => (
                    <div
                      key={data._id || data.configuration_id || index}
                      className={`vr-list-item ${editingIndex === index ? "vr-editing" : ""}`}
                    >
                      <div className="vr-item-content">
                        <h4 className="vr-item-title">{data.configuration}</h4>
                        <p className="vr-item-url">{data.iframe_url}</p>
                        <div className="vr-visibility-status">
                          {data.is_user_vr ? (
                            <span className="status-public">Visible to All</span>
                          ) : (
                            <span className="status-private">Agent only</span>
                          )}
                        </div>
                      </div>
                      <div className="vr-item-actions">
                        <button type="button" className="vr-action-btn vr-edit-btn" onClick={() => handleEdit(index)} title="Edit">
                          <EditIcon />
                        </button>
                        <button type="button" className="vr-action-btn vr-delete-btn" onClick={() => handleRemove(index)} title="Delete">
                          <DeleteIcon />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="vr-form-section">
              <h3 className="vr-form-heading">
                {editingIndex !== null
                  ? "Edit VR Tour"
                  : urlIframe.three_sixty.length > 0
                    ? "Add Another"
                    : "Add New VR Tour"}
              </h3>

              <div className="vr-form-grid">
                <SelectInput
                  label="Configuration"
                  disabled={otherPopup}
                  required={true}
                  value={formData.configuration_id}
                  placeholder="Select an Option"
                  options={[
                    ...(Array.isArray(vrData?.data?.units)
                      ? vrData.data.units.map((unit) => ({ value: unit?._id, label: unit?.name }))
                      : []),
                    { value: "others", label: "Other's" },
                  ]}
                  onChange={(e) => {
                    if (e.target.value === "others") {
                      setOtherPopup(false);
                      setFormData((prev) => ({ ...prev, configuration_id: "others", configuration: "" }));
                    } else {
                      const selected = vrData?.data?.units?.find((unit) => unit._id === e.target.value);
                      setFormData((prev) => ({ ...prev, configuration_id: selected?._id || "", configuration: selected?.name || "" }));
                    }
                  }}
                />

                {formData.configuration_id === "others" && (
                  <TextInput
                    label="Title"
                    required={true}
                    value={formData.configuration}
                    onChange={(e) => setFormData((prev) => ({ ...prev, configuration: e.target.value }))}
                  />
                )}

                {otherPopup && (
                  <SelectInput
                    label="All Configurations"
                    value={formData.configuration_id}
                    required={true}
                    placeholder="Select an Option"
                    options={Array.isArray(units?.data) ? units.data.map((unit) => ({ value: unit._id, label: unit.name })) : []}
                    onChange={(e) => {
                      const selected = units?.data?.find((unit) => unit._id === e.target.value);
                      setFormData((prev) => ({ ...prev, configuration_id: selected?._id || "", configuration: selected?.name || "" }));
                    }}
                  />
                )}

                <div className="vr-url-input-wrapper">
                  <TextInput
                    label="Iframe / URL"
                    required={true}
                    value={formData.iframe_url}
                    onChange={(e) => setFormData((prev) => ({ ...prev, iframe_url: e.target.value }))}
                  />
                  {formData.iframe_url.trim().length > 0 && (
                    <button type="button" className="vr-add-btn" onClick={handleAddEntry}>
                      {editingIndex !== null ? "Update" : "Add"}
                    </button>
                  )}
                </div>

                <div className="vr-checkbox-wrapper">
                  <label className="vr-checkbox-label">
                    <input
                      type="checkbox"
                      className="vr-checkbox-input"
                      checked={formData.is_user_vr}
                      onChange={(e) => setFormData((prev) => ({ ...prev, is_user_vr: e.target.checked }))}
                    />
                    <span className="vr-checkbox-text">
                      User Available
                      {!formData.is_user_vr && <span className="disclaimer-text">(VR hidden from users)</span>}
                    </span>
                  </label>
                </div>

                {editingIndex !== null && (
                  <button type="button" className="vr-cancel-edit-btn" onClick={handleCancelEdit}>
                    Cancel Edit
                  </button>
                )}
              </div>
            </div>

            {urlIframe.three_sixty.length > 0 && (
              <div className="vr-submit-section">
                <button type="button" className="vr-submit-btn" onClick={handleSubmit}>
                  Submit All
                </button>
              </div>
            )}
          </>
        ) : (
          // ✅ PREVIEW VIDEO TAB — now uses AddImage upload pattern
          <div className="vr-form-section">
            <h3 className="vr-form-heading">Upload Preview Video</h3>

            <div className="vr-form-grid">
              <div className="vr-upload-field">
                <label className="vr-upload-label">Preview Video</label>
                <input
                  type="file"
                  accept="video/*"
                  className="vr-file-input"
                  id="vr-preview-video-upload"
                  style={{ display: "none" }}
                  onChange={handlePreviewVideoChange}
                  disabled={videoUploading}
                />
                <label
                  htmlFor="vr-preview-video-upload"
                  className="label-class-images"
                  style={{ cursor: videoUploading ? "not-allowed" : "pointer" }}
                >
                  {videoUploading ? "Uploading..." : "Click to Upload Video"}
                </label>
              </div>

              {/* ✅ Progress Bar */}
              {videoUploading && (
                <div style={{ marginTop: "10px" }}>
                  <div style={{ color: "#666", marginBottom: "5px" }}>
                    Uploading video... {uploadProgress}%
                  </div>
                  <div style={{
                    width: "100%", height: "20px", backgroundColor: "#e0e0e0",
                    borderRadius: "10px", overflow: "hidden",
                  }}>
                    <div style={{
                      width: `${uploadProgress}%`, height: "100%",
                      backgroundColor: uploadProgress === 100 ? "#4CAF50" : "#2196F3",
                      transition: "width 0.3s ease",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: "white", fontSize: "12px", fontWeight: "bold",
                    }}>
                      {uploadProgress > 0 && `${uploadProgress}%`}
                    </div>
                  </div>
                </div>
              )}

              {/* ✅ Video Preview with remove button */}
              {previewVideoPreview && !videoUploading && (
                <div style={{ position: "relative", marginTop: "10px", width: "100%", maxWidth: "400px" }}>
                  <video className="vr-video-preview" controls src={previewVideoPreview} style={{ borderRadius: "8px", width: "135%" }} />
                  <button
                    type="button"
                    onClick={handleRemoveVideo}
                    style={{
                      position: "absolute", top: "8px", right: "-120px",
                      padding: "4px 8px", fontSize: "18px",
                      backgroundColor: "rgba(0,0,0,0.6)", color: "white",
                      border: "none", borderRadius: "50%", cursor: "pointer",
                      fontWeight: "bold", lineHeight: 1,
                      width: "28px", height: "28px",
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}
                    title="Remove video"
                  >
                    ×
                  </button>
                </div>
              )}

              <div className="vr-submit-section">
                <button
                  type="button"
                  className="vr-submit-btn"
                  onClick={handlePreviewVideoSubmit}
                  disabled={videoUploading || (!uploadedVideoUrl && !vrData?.data?.three_sixty_prev_video)}
                >
                  {vrData?.data?.three_sixty_prev_video ? "Update Preview Video" : "Upload Preview Video"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddVr;